$(document).ready(function () {
    $('#communities-table').DataTable({
        dom: 'fBlrtip',
        language: {
            url: '/data_tables_translation.json'
        }
    });
});
